import React, {Fragment} from 'react';
import {Form, Field} from 'react-final-form';
import {Popup, Text, Select} from '../../../../components';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import DeleteIcon from '@material-ui/icons/Delete';
import Button from '@material-ui/core/Button';
import { FieldArray } from 'react-final-form-arrays';
import arrayMutators from 'final-form-arrays';
import {connect} from 'react-redux';

function External_crm_owners_popup(props){

  function onSubmit(params){
    console.log(params, 'PARAMS');
    let new_user_mappings=[];
    for(let um of params.user_mapping){let eco=props.external_crm_owners[props.crm_login.id][um.external_crm_id]; um.secondary_crm_id=eco.secondary_internal_id; new_user_mappings.push(um);}
    params.user_mapping=new_user_mappings;
    props.updateExternalCrmOwners(params);
  }

  let crm_name=props.crm_login.crm_type.toLowerCase();
  let initial_values={user_mapping:[{}]}; if(props.initial_values!=undefined){initial_values={user_mapping:props.initial_values}}
  initial_values['crm_login_id']=props.crm_login.id;
  console.log(props.initial_values, props.external_crm_owners, 'GOO');
  return(
    <Form
      initialValues={initial_values}
      onSubmit={onSubmit}
      mutators={{
        ...arrayMutators
      }}
      {...props}
    >
      {form_props => (
        <form onSubmit={form_props.handleSubmit}>
        <Popup accept_button='Save' accept_button_click={()=>{form_props.form.submit(); form_props.form.reset(); props.handleClose();}} handleClose={props.handleClose} always_open title='hubspot_owners_popup_title' content={
          <div style={{width:'95vw', maxWidth:'600px'}}>
          <FieldArray name='user_mapping'>
          {({ fields }) =>{
            let pre_users=[]; let check_users=[];
            let pre_external_crm_owners=[]; let check_external_crm_owners=[];
            for(let f of fields.value){if(!check_users.includes(f.user_workspace_id)){check_users.push(f.user_workspace_id);} if(!check_external_crm_owners.includes(f.external_crm_id)){check_external_crm_owners.push(f.external_crm_id);}}
            for(let ho_k in props.external_crm_owners[props.crm_login.id]){let ho=props.external_crm_owners[props.crm_login.id][ho_k]; if(!check_external_crm_owners.includes(ho.internal_id)){pre_external_crm_owners.push({id:ho.internal_id, name:ho.firstName+' '+ho.lastName});}}
            for(let u_k in props.workspace.all_user_workspaces){let u=props.workspace.all_user_workspaces[u_k]; if(u.invisible!=true && !check_users.includes(u.id)){pre_users.push({id:u.id, name:u.first_name+' '+u.last_name});}}
            return(
          <div style={{width:'95vw', maxWidth:'600px', minHeight:'300px'}}>
            <Grid container style={{width:'calc(100% - 40px)', marginLeft:'20px', marginTop:'20px'}}>
              <Grid item xs={6}><Typography style={{width:'calc(100% - 20px)', marginLeft:'10px'}} color='primary'>ProspectSafari</Typography></Grid>
              <Grid item xs={6}><Typography style={{width:'calc(100% - 20px)', marginLeft:'10px'}} color='primary'>{window.capitalizeFirstLetter(crm_name)}</Typography></Grid>
            </Grid>
            {fields.map((name, index) => (
              <Grid container style={{width:'calc(100% - 40px)', marginLeft:'20px'}}>
                <Grid item xs={5}><Field name={`${name}.user_workspace_id`}>{(f)=>{let users=JSON.parse(JSON.stringify(pre_users)); if(f.input.value!=''){users.push({id:f.input.value, name:props.workspace.all_user_workspaces[f.input.value].first_name+' '+props.workspace.all_user_workspaces[f.input.value].last_name});} return(<Select variant='not_outlined' color='transparent' name={`${name}.user_workspace_id`} select_data={users}/>)}}</Field></Grid>
                <Grid item xs={1}/>
                <Grid item xs={5}><Field name={`${name}.external_crm_id`}>{(f)=>{let external_crm_owners=JSON.parse(JSON.stringify(pre_external_crm_owners)); if(f.input.value!='' && props.external_crm_owners[props.crm_login.id][f.input.value]!=undefined){external_crm_owners.push({id:f.input.value, name:props.external_crm_owners[props.crm_login.id][f.input.value].firstName+' '+props.external_crm_owners[props.crm_login.id][f.input.value].lastName});} return(<Select variant='not_outlined' color='transparent' name={`${name}.external_crm_id`} select_data={external_crm_owners}/>)}}</Field></Grid>
                <Grid item xs={1} style={{display:'flex', justifyContent:'center', alignItems:'center'}}><DeleteIcon style={{marginTop:'15px', cursor:'pointer'}} color='secondary' onClick={()=>{fields.remove(index);}}/></Grid>
              </Grid>
          ))}
          <div style={{width:'100%', display:'flex', justifyContent:'center', alignItems:'center', marginTop:'40px', marginBottom:'50px'}}>{(fields.length>=Object.keys(props.workspace.all_user_workspaces).length)?null:<Button type="button" variant='outlined' color='secondary' onClick={() => {fields.push({}, undefined)}} style={{marginRight:'10px'}}>Add user</Button>}</div>
          </div>
        )}}
          </FieldArray>
          </div>
        }/>
        </form>
      )}
    </Form>
  )
}

export default connect(ss, dd)(External_crm_owners_popup)


function ss(state){
  return{}
}

function dd(dispatch){
  return{
    updateExternalCrmOwners:(params)=>{dispatch({type:'REQUEST_UPDATE_EXTERNAL_CRM_OWNERS', payload:params});}
  }
}
